module.exports = __webpack_public_path__ + "img/banner_1@2x.edfcd3ca.png";